import React from "react";
import dummyPreview from "../../../assets/dummyPreview.png"
import classes from "./imagePreview.module.css";

export const ImagePreview = ({ url, label }) => {
  const imgSrc = url || dummyPreview;

  return (
    <div className={classes.previewBox}>
      <div className={classes.imageWrapper}>
        <img src={imgSrc} alt={label} className={classes.image} />
      </div>
      {label && <span className={classes.imageLabel}>{label}</span>}
    </div>
  );
};
